import { render, staticRenderFns } from "./WorkshopPage.vue?vue&type=template&id=d7158df8&scoped=true&"
import script from "./WorkshopPage.vue?vue&type=script&lang=js&"
export * from "./WorkshopPage.vue?vue&type=script&lang=js&"
import style0 from "./WorkshopPage.vue?vue&type=style&index=0&id=d7158df8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7158df8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
